/* eslint-disable camelcase,no-empty-pattern */

import Vue from 'vue'
import Vuex from 'vuex'
import firebase from 'firebase/app'
import 'firebase/database'
import 'firebase/functions'
import 'firebase/storage'
import TEST_METHOD_CONFIG from '@/config/test-methods'

import authStore from '@/state/auth'
import builderStore from '@/state/builder'
import testStore from '@/state/tests'
import adminStore from '@/state/admin'
import assetStore from '@/state/assets'
import categoriesStore from './state/categories'
import walletStore from '@/state/wallet'
import shopifyStore from '@/state/shopify'
import templatesTagsStore from '@/state/templates-tags'
import fontsStore from '@/state/fonts'
import placementStore from '@/state/placements'
import integrationStore from '@/state/integrations'
import logsStore from '@/state/logs'
import projectAuthorStore from '@/state/projectAuthor'
import qrCodes from '@/state/qrCodes'
import { functions } from '@/firebase'
import config from '@/config/config'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    auth: authStore,
    builder: builderStore,
    test: testStore,
    admin: adminStore,
    assets: assetStore,
    wallet: walletStore,
    shopify: shopifyStore,
    templatesTags: templatesTagsStore,
    placements: placementStore,
    fonts: fontsStore,
    integrations: integrationStore,
    userLogs: logsStore,
    projectAuthor: projectAuthorStore,
    qrCodes: qrCodes,
    categories: categoriesStore
  },
  state: {
    betaCodes: {},
    apiUrl: 'https://api.edamam.com/search',
    testMethods: TEST_METHOD_CONFIG,
    viewportWidth: null,
    viewportHeight: null,
    analyticsQueue: [],
    logs: null,
    appVersion: null,
    pendingVersion: null,
    showAchievements: false,
    projectsTableView: true,
    uploadingAssetInSafari: false
  },
  mutations: {
    // setBetaCodes (state, payload) {
    //   state.betaCodes = { ...payload }
    // },
    setViewportDimensions (state, payload) {
      state.viewportWidth = payload.width
      state.viewportHeight = payload.height
    },
    pushAnalyticsEvent (state, payload) {
      state.analyticsQueue.push(payload)
    },
    popAnalyticsEvent (state) {
      state.analyticsQueue.shift()
    },
    setLogs (state, payload) {
      state.logs = payload
    },
    updateAppVersion (state, newVersion) {
      if (!state.appVersion) {
        state.appVersion = newVersion
      } else {
        if (newVersion && state.appVersion.hash !== newVersion.hash) {
          state.pendingVersion = newVersion
        }
      }
    },
    toggleAchievements (state) {
      state.showAchievements = !state.showAchievements
    },
    setShowAchievements (state, payload) {
      state.showAchievements = payload
    },
    updateProjectsView (state, newValue) {
      state.projectsTableView = newValue
    },
    setUploadingAssetInSafari (state, newValue) {
      state.uploadingAssetInSafari = newValue
    }
  },
  getters: {
    betaCodes (state) {
      return state.betaCodes
    },
    testMethods (state) {
      return state.testMethods
    },
    analyticsQueue (state) {
      return state.analyticsQueue
    },
    logs (state) {
      return state.logs
    },
    appVersion (state) {
      return state.appVersion
    },
    isPendingUpdate (state) {
      return !!state.pendingVersion &&
        (!state.appVersion || state.appVersion.hash !== state.pendingVersion.hash)
    },
    showAchievements (state) {
      return !!state.showAchievements
    },
    uploadingAssetInSafari (state) {
      return state.uploadingAssetInSafari
    }
  },
  actions: {
    updateProjectsView ({ commit }, newValue) {
      commit('updateProjectsView', newValue)
    },
    async logAchievement ({ rootState, commit }, { achievement, value = null }) {
      // If the user hasn't earned this achievement already
      if (rootState.auth.user && (!rootState.auth.user.goals || !rootState.auth.user.goals[achievement])) {
        var update = {}
        update[`goals/${achievement}`] = value || true
        await firebase
          .database()
          .ref('users')
          .child(rootState.auth.user.uid)
          .update(update)
        commit('pushAnalyticsEvent', { action: `${achievement} achievement completed` })
      }
    },
    // Analytics reports
    async getAnalyticsReport ({ }, testId) {
      const report = await functions.httpsCallable('getAnalyticsReport')({ testId })
      if (report.data) return report.data || null
      else return null
    },
    // Logs
    async getLogs ({ commit }) {
      return firebase
        .database()
        .ref('logs')
        .once('value', snapshot => {
          commit('setLogs', snapshot.val())
        })
    },

    async sendFeedbackToSlack ({ rootState }, { message, feature }) {
      const result = await functions.httpsCallable('zapier-sendFeedbackToSlack')({
        zapierWebhook: config.FEEDBACK_WEBHOOK,
        message,
        feature,
        username: rootState.auth.user.username,
        email: rootState.auth.user.email
      })
      return result
    }
  }
})
